import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { sendSalesEmail } from '@pages/ContactSales/api/sendSalesEmail';
import { ContactSalesForm } from '@pages/ContactSales/components/Form';
import { ContactSalesLeftSection } from '@pages/ContactSales/components/LeftSection';
import { ContactSalesSuccess } from '@pages/ContactSales/components/Success';
import { useAPI } from '@providers/useAPI';
import { useInitContext } from '@providers/InitProvider';
import { useMutation } from '@tanstack/react-query';
import { Initialization } from '@wrappers/Main/Initialization';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { LandingPageFooter } from './components/Footer';
import { LandingPageHeader } from './components/Header';
import { buildSalesEmailRequestBody } from './helpers/buildSalesEmailRequestBody';
import { Wrapper } from './styles/Wrapper';

export const ContactSalesPage = () => {
  const { isInitialized } = useInitContext();
  const { call } = useAPI();
  const [formState, setFormState] = useState({
    details: {
      name: '',
      surname: '',
      email: '',
      phone: '',
    },
    typeOfWork: '',
    companyName: '',
    role: '',
    interested: {
      asone: false,
      asWeb: false,
      attorney: false,
      notSure: false,
    },
    tools: {
      asd: false,
      asone: false,
      attorneyView: false,
      cat: false,
      eclipse: false,
      maxscribe: false,
      word: false,
      other: false,
      otherName: '',
    },
    autoScriptAccount: false,
    outsource: '',
    outsourceTo: '',
    notes: '',
    notSureNotes: '',
  });

  const salesEmailMutation = useMutation({
    mutationFn: () => sendSalesEmail({ call, requestBody: buildSalesEmailRequestBody(formState) }),
    onSuccess: () => {
      window.scroll(0, 0);
    },
    onError: () => {
      toast.error('Unable to send your message. Please try again.');
    },
  });

  if (!isInitialized) {
    return <Initialization />;
  }

  return (
    <Wrapper>
      <LandingPageHeader />

      <main>
        {salesEmailMutation.isSuccess ? (
          <ContactSalesSuccess />
        ) : (
          <>
            <ContactSalesLeftSection formState={formState} setFormState={setFormState} />
            <ContactSalesForm
              formState={formState}
              setFormState={setFormState}
              isSubmitting={salesEmailMutation.isPending}
              onSubmit={() => salesEmailMutation.mutate()}
            />
          </>
        )}
      </main>

      <LandingPageFooter />

      {salesEmailMutation.isPending ? (
        <div className="fixed inset-0 z-[100]">
          <AbsoluteSpinner overlay={true} />
        </div>
      ) : null}
    </Wrapper>
  );
};
